import { Checkbox, FormControlLabel } from "@mui/material";
import React, { useEffect, useState } from "react";

function CheckBox(props) {
  const {
    label,
    handleChange,
    value,
    checkboxstatus,
    name,
    disab,
    id,
    className,
    add,
    view,
    onCheckboxChange,
  } = props;
  const [isChecked, setIsChecked] = useState(false);
  // console.log(props.value);
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  // console.log("checked box");

    handleChange(event);
    // if (onCheckboxChange) {
    //   onCheckboxChange(event.target.checked);
    // }
  };
  useEffect(() => {
    // console.log(props.add);

  
      // console.log(props.add);
      
      props.add == true
        ? setIsChecked(true)
        : setIsChecked(false);
    
  }, [props.add]);

  return (
    <FormControlLabel
      style={{
        flexDirection: "row-reverse",
        justifyContent: "start",
        marginInline: "0",
      }}
      label={<label className="label">{label}</label>}
      control={
        <Checkbox
          name={name}
          onChange={handleCheckboxChange}
          checked={isChecked}
          disabled={disab||view}
          className={className}
          id={id}
          sx={{
            color: "rgba(0, 0, 0, 0.6)",
            "&.Mui-checked": {
              color: "#1976d2",
            },
          }}
        />
      }
    />
  );
}

export default React.memo(CheckBox);
